import BaseController from "./base_controller"

// Connects to data-controller="account-deletion"
export default class extends BaseController {
  static targets = ["modal", "passwordInput", "submitButton"]

  declare readonly modalTarget: HTMLDialogElement
  declare readonly passwordInputTarget: HTMLInputElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly hasModalTarget: boolean
  declare readonly hasPasswordInputTarget: boolean
  declare readonly hasSubmitButtonTarget: boolean

  connect(): void {
    super.connect()
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("click", this.handleBackdropClick.bind(this))
    }
  }

  disconnect(): void {
    super.disconnect()
  }

  show(event: MouseEvent): void {
    event.preventDefault()
    if (this.hasModalTarget) {
      this.modalTarget.showModal()
      if (this.hasPasswordInputTarget) {
        setTimeout(() => this.passwordInputTarget.focus(), 100)
      }
    }
  }

  cancel(event: MouseEvent): void {
    event.preventDefault()
    this.closeModal()
  }

  private closeModal(): void {
    if (this.hasModalTarget) {
      this.modalTarget.close()
      if (this.hasPasswordInputTarget) {
        this.passwordInputTarget.value = ""
      }
    }
  }

  private handleBackdropClick(event: MouseEvent): void {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }
}
